<template>
  <div>
    <Navbar />
    <v-container fluid>
      <v-row class="px-md-5 px-2 py-5">
        <v-col cols="12">
          <v-row>
            <v-col cols="12" sm="8">
              <v-card class="mx-auto d-flex align-center pt-5 px-3">
                <v-card-text class="pb-0">
                  <div class="d-md-flex d-block justify-space-between">
                    <div class="mb-md-0 mb-3">
                      <p style="color:rgb(105,108,255); font-size:26px; margin-bottom:30px;">Congratulations Admin!</p>
                      <p class="text-body-1">You have done 92% more appeals today. <br>
                        Check your new raising badge in your profile.</p>
                      <div>
                        <v-btn small depressed color="rgba(105,108,255,0.25)" style="color:rgb(105,108,255)">
                          view badges
                        </v-btn>
                      </div>
                    </div>
                    <div class="d-flex align-end">
                      <img width="213" src="../assets/dashboard.png">
                    </div>
                  </div>
                </v-card-text>

              </v-card>
              <v-card class="mx-auto d-flex align-center pt-5 px-3 mt-6">
                <v-card-text class="px-0">
                  <vc-donut foreground="grey" :size="180" unit="px" :thickness="100" has-legend legend-placement="top"
                    :sections="sections" :start-angle="0" :auto-adjust-text-size="true" :total="totalNumber">
                  </vc-donut>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="4">
              <v-row>
                <v-col cols="12" md="6" v-for="info, index in dataStatic" :key="index">
                  <v-card class="mx-auto d-flex align-center py-3" @click="$router.push(info.link)">
                    <v-card-text class="text-center pr-0">
                      <v-icon size="30" :color="`${info.color}`">{{ info.icon }}</v-icon>
                    </v-card-text>
                    <v-card-text class="pl-1">
                      <p class="mb-1 text-caption font-weight-bold">{{ info.text }}</p>
                      <p class="font-weight-bold mb-0 grey--text text--darken-2">
                        <count-to :start-val="0" :end-val="info.number" :duration="info.duration"
                          class="title font-weight-bold" />
                      </p>
                    </v-card-text>

                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Navbar from '@/components/navbar.vue';
import CountTo from 'vue-count-to';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "Dashboard",
  components: { Navbar, CountTo },
  data: () => ({
  }),
  created() {
    this.getPerson();
  },
  computed: {
    ...mapGetters("personal", ["person"]),
    totalNumber() {
      return this.person.length
    },
    dataStatic() {
      return [
        {
          icon: 'mdi-check-all',
          text: 'Murojaatlar',
          color: 'green',
          number: this.person.length,
          duration: 3600,
          link:'/dashboard'
        },
        {
          icon: 'mdi-account-tie',
          text: 'Rahbariyat',
          color: 'blue darken-4',
          number: this.person.filter((x) => { return x.send_who == 'Rahbariyat' }).length,
          duration: 3000,
          link:"/admin"
        },
        {
          icon: 'mdi-currency-usd-off',
          text: 'Korrupsiyaga qarshi',
          color: 'red',
          number: this.person.filter((x) => { return x.send_who == 'Korrupsiyaga qarshi' }).length,
          duration: 2000,
          link:"/korrupsiya"
        },
        {
          icon: 'mdi-gold',
          text: 'Foydali qazilma...',
          color: 'amber',
          number: this.person.filter((x) => { return x.send_who == 'Foydali qazilma konlari geologiyasi fakulteti' }).length,
          duration: 3300,
          link:"/foydali"
        },
        {
          icon: 'mdi-gas-burner',
          text: 'Neft va Gaz...',
          color: 'info',
          number: this.person.filter((x) => { return x.send_who == 'Neft va Gaz konlari geologiyasi fakulteti' }).length,
          duration: 3300,
          link:"/neft-gaz"
        },
        {
          icon: 'mdi-text-box-multiple',
          text: 'Boshqalar',
          color: 'teal',
          number: this.person.filter((x) => { return x.send_who == 'Boshqa' }).length,
          duration: 3300,
          link:"/boshqalar"
        }
      ]
    },
    sections() {
      return [
        { label: 'Rahbariyat', value: this.person.filter((x) => { return x.send_who == 'Rahbariyat' }).length, color: '#696cff' },
        { label: 'Korrupsiyaga qarshi', value: this.person.filter((x) => { return x.send_who == 'Korrupsiyaga qarshi' }).length, color: 'red' },
        { label: 'Foydali qazilma...', value: this.person.filter((x) => { return x.send_who == 'Foydali qazilma konlari geologiyasi fakulteti' }).length, color: '#ffff58' },
        { label: 'Neft va Gaz...', value: this.person.filter((x) => { return x.send_who == 'Neft va Gaz konlari geologiyasi fakulteti' }).length, color: '#35CFEF' },
        { label: 'Boshqalar', value: this.person.filter((x) => { return x.send_who == 'Boshqa' }).length, color: '#3b9b9b' }
      ]
    }
  },
  methods: {
    ...mapActions("personal", ["getPerson"]),
    // generatePDF(){
    //   const routeData = this.$route.path; 
    //   window.open(routeData, "_blank")
    // }
  }
}
</script>

<style lang="scss" scoped></style>